import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Flex } from '@osmosis/react-ui/components/Box';
import Toggle from '../../../../Toggle';
import { P } from '@osmosis/react-ui/components/Text';
import { useQuizContext } from '../../../../../context/QuizContext';

/**
 * Elimination Tool Toggler.
 */
export const EliminationToolToggle = () => {
  const intl = useIntl();
  const {
    setShowElimination,
    showElimination,
    eliminationItems,
    setIsEliminated,
    isEliminated,
    isAnswered,
  } = useQuizContext();

  useEffect(() => {
    setIsEliminated(false);
  }, [showElimination, setIsEliminated, isAnswered]);

  useEffect(() => {
    setShowElimination(false);
  }, [isAnswered, setShowElimination]);

  return (
    <Flex alignItems="center" mt="20px">
      <P fontSize="14px" fontWeight={400} color="gray40" mr="5px">
        <FormattedMessage
          id="quiz.elimination-tool-header"
          defaultMessage="Elimination tool"
        />
      </P>
      <Toggle
        size={13}
        onChange={() => setShowElimination(!showElimination)}
        checked={showElimination}
        data-testid="elimination-toggle"
        aria-label={intl.formatMessage({
          id: 'quiz.elimination-tool-aria',
          defaultMessage: 'Toggle elimination tool',
        })}
      />

      {eliminationItems.length > 0 && (
        <>
          {isEliminated ? (
            <P
              fontSize="14px"
              fontWeight={400}
              color="primary"
              ml="5px"
              sx={{ cursor: 'pointer' }}
              onClick={() => setIsEliminated(false)}
              data-testid="elimination-toggle"
            >
              <FormattedMessage
                id="quiz.elimination-tool-show"
                defaultMessage="Show eliminated answers"
              />
            </P>
          ) : (
            <P
              fontSize="14px"
              fontWeight={400}
              color="primary"
              ml="5px"
              sx={{ cursor: 'pointer' }}
              onClick={() => setIsEliminated(true)}
              data-testid="elimination-toggle"
            >
              <FormattedMessage
                id="quiz.elimination-tool-hide"
                defaultMessage="Hide eliminated answers"
              />
            </P>
          )}
        </>
      )}
    </Flex>
  );
};
